import type { GROUP_TYPE } from '../enums';
import type { SortChanges } from '../sort.type';
import type { PagedListRequest } from './pagedListRequest.type';

export enum GROUPS_LIST_SORT_FIELD {
  NAME = 'name',
  CREATED_DATE = 'created_date',
}

export type GroupListRequestFiltersData = Partial<SortChanges<GROUPS_LIST_SORT_FIELD>> &
  PagedListRequest & {
    term?: string;
    types?: GROUP_TYPE[];
  };
